import { Injectable, inject } from '@angular/core';
import { HTTP_AP_AddFilesToMortgageOfferParserBatch_Request } from '@api-new/documentservice/HTTP_AP_AddFilesToMortgageOfferParserBatch_Request';
import { HTTP_AP_AddSeedFileToMortgageOfferParserBatch_Request } from '@api-new/documentservice/HTTP_AP_AddSeedFileToMortgageOfferParserBatch_Request';
import { HTTP_AP_CreateMortgageOfferParserBatch_Request } from '@api-new/documentservice/HTTP_AP_CreateMortgageOfferParserBatch_Request';
import { HTTP_AP_DeleteMortgageOfferParserBatchDocument_Request } from '@api-new/documentservice/HTTP_AP_DeleteMortgageOfferParserBatchDocument_Request';
import { HTTP_AP_GenerateMortgagePDF_Request } from '@api-new/documentservice/HTTP_AP_GenerateMortgagePDF_Request';
import { HTTP_AP_GenerateMortgagePDF_Response } from '@api-new/documentservice/HTTP_AP_GenerateMortgagePDF_Response';
import { HTTP_AP_GetMortgageOfferParserBatchDocument_Request } from '@api-new/documentservice/HTTP_AP_GetMortgageOfferParserBatchDocument_Request';
import { HTTP_AP_GetMortgageOfferParserBatchDocument_Response } from '@api-new/documentservice/HTTP_AP_GetMortgageOfferParserBatchDocument_Response';
import { HTTP_AP_GetMortgageOfferParserBatch_Request } from '@api-new/documentservice/HTTP_AP_GetMortgageOfferParserBatch_Request';
import { HTTP_AP_ListMortgageOfferParserBatchDocuments_Request } from '@api-new/documentservice/HTTP_AP_ListMortgageOfferParserBatchDocuments_Request';
import { HTTP_AP_ListMortgageOfferParserBatchDocuments_Response } from '@api-new/documentservice/HTTP_AP_ListMortgageOfferParserBatchDocuments_Response';
import { HTTP_AP_ListMortgageOfferParserBatches_Request } from '@api-new/documentservice/HTTP_AP_ListMortgageOfferParserBatches_Request';
import { HTTP_AP_ListMortgageOfferParserBatches_Response } from '@api-new/documentservice/HTTP_AP_ListMortgageOfferParserBatches_Response';
import { HTTP_AP_MortgageOfferParserBatch } from '@api-new/documentservice/HTTP_AP_MortgageOfferParserBatch';
import { HTTP_AP_ProcessMortgageOfferParserBatch_Request } from '@api-new/documentservice/HTTP_AP_ProcessMortgageOfferParserBatch_Request';
import { HTTP_CP_CreateDocument_Request } from '@api-new/documentservice/HTTP_CP_CreateDocument_Request';
import { HTTP_CP_DeleteDocument_Request } from '@api-new/documentservice/HTTP_CP_DeleteDocument_Request';
import { HTTP_CP_Document } from '@api-new/documentservice/HTTP_CP_Document';
import { HTTP_CP_ListDocuments_Response } from '@api-new/documentservice/HTTP_CP_ListDocuments_Response';
import { HTTP_CP_UpdateDocument_Request } from '@api-new/documentservice/HTTP_CP_UpdateDocument_Request';
import { HTTP_X_GenerateUploadUrl_Request } from '@api-new/documentservice/HTTP_X_GenerateUploadUrl_Request';
import { HTTP_X_GenerateUploadUrl_Response } from '@api-new/documentservice/HTTP_X_GenerateUploadUrl_Response';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class DocumentApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_AddFilesToMortgageOfferParserBatch(
    request: HTTP_AP_AddFilesToMortgageOfferParserBatch_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/document-service/ap/AddFilesToMortgageOfferParserBatch`, request, options);
  }

  HTTP_AP_AddSeedFileToMortgageOfferParserBatch(
    request: HTTP_AP_AddSeedFileToMortgageOfferParserBatch_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/document-service/ap/AddSeedFileToMortgageOfferParserBatch`, request, options);
  }

  HTTP_AP_CreateMortgageOfferParserBatch(
    request: HTTP_AP_CreateMortgageOfferParserBatch_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_MortgageOfferParserBatch> {
    return this.httpClient.post(`/document-service/ap/CreateMortgageOfferParserBatch`, request, options);
  }

  HTTP_AP_DeleteMortgageOfferParserBatchDocument(
    request: HTTP_AP_DeleteMortgageOfferParserBatchDocument_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.delete(`/document-service/ap/DeleteMortgageOfferParserBatchDocument`, { params: request });
  }

  HTTP_AP_GenerateMortgagePDF(
    request: HTTP_AP_GenerateMortgagePDF_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GenerateMortgagePDF_Response> {
    return this.httpClient.get(`/document-service/ap/GenerateMortgagePDF`, { params: request });
  }

  HTTP_AP_GetMortgageOfferParserBatch(
    request: HTTP_AP_GetMortgageOfferParserBatch_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_MortgageOfferParserBatch> {
    return this.httpClient.get(`/document-service/ap/GetMortgageOfferParserBatch`, { params: request });
  }

  HTTP_AP_GetMortgageOfferParserBatchDocument(
    request: HTTP_AP_GetMortgageOfferParserBatchDocument_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetMortgageOfferParserBatchDocument_Response> {
    return this.httpClient.get(`/document-service/ap/GetMortgageOfferParserBatchDocument`, { params: request });
  }

  HTTP_AP_ListMortgageOfferParserBatchDocuments(
    request: HTTP_AP_ListMortgageOfferParserBatchDocuments_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListMortgageOfferParserBatchDocuments_Response> {
    return this.httpClient.get(`/document-service/ap/ListMortgageOfferParserBatchDocuments`, { params: request });
  }

  HTTP_AP_ListMortgageOfferParserBatches(
    request: HTTP_AP_ListMortgageOfferParserBatches_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListMortgageOfferParserBatches_Response> {
    return this.httpClient.get(`/document-service/ap/ListMortgageOfferParserBatches`, { params: request });
  }

  HTTP_AP_ProcessMortgageOfferParserBatch(
    request: HTTP_AP_ProcessMortgageOfferParserBatch_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.post(`/document-service/ap/ProcessMortgageOfferParserBatch`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_CreateDocument(request: HTTP_CP_CreateDocument_Request, options?: IRequestOptions): Observable<HTTP_CP_Document> {
    return this.httpClient.post(`/document-service/cp/CreateDocument`, request, options);
  }

  HTTP_CP_DeleteDocument(request: HTTP_CP_DeleteDocument_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.delete(`/document-service/cp/DeleteDocument`, { params: request });
  }

  HTTP_CP_ListDocuments(request?: undefined, options?: IRequestOptions): Observable<HTTP_CP_ListDocuments_Response> {
    return this.httpClient.get(`/document-service/cp/ListDocuments`, { params: request });
  }

  HTTP_CP_UpdateDocument(request: HTTP_CP_UpdateDocument_Request, options?: IRequestOptions): Observable<HTTP_CP_Document> {
    return this.httpClient.put(`/document-service/cp/UpdateDocument`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_X_GenerateUploadUrl(
    request: HTTP_X_GenerateUploadUrl_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_X_GenerateUploadUrl_Response> {
    return this.httpClient.post(`/document-service/x/GenerateUploadUrl`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/document-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty
}
